 export const environment = {
    production: false,
    baseUrl: 'https://api-visor-athenea.confirma.com.co',
    //baseUrl: 'http://localhost:3009',
    //baseUrl: 'http://localhost:8000',
    // baseUrl: 'https://api-dev.confirma.com.co',
    clientId: 'GiXRHnbyeYguhP2jMDfg7VG2PxUdFFFhCMhAdlK6',
    clientSecret: 'xwhlVlRxoTcn1LGco1ChQt4xLNxpLNKqvOmke7JbQk9kni0R3B913SlVGG4vvIjgp8tDS8Yvo6hEr1z2puyLju4mTkvlTbyZJO4i0ySI1qiEmm7xwbGUZU6SpKhYOawF',
    wompi_data_redirect_url: 'https://app.confirma.com.co/#/verifytransaction',
    wompi_url_verify_trasaction: 'https://sandbox.wompi.co/v1/transactions/',
};
